import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface SimpleCustomerDetailsProps {
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  specialRequests: string;
  contactMethod: string;
  onNameChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onSpecialRequestsChange: (value: string) => void;
  onContactMethodChange: (value: string) => void;
}

export function SimpleCustomerDetails({
  customerName,
  customerEmail,
  customerPhone,
  specialRequests,
  contactMethod,
  onNameChange,
  onEmailChange,
  onPhoneChange,
  onSpecialRequestsChange,
  onContactMethodChange
}: SimpleCustomerDetailsProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>3. Your Details</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="customer-name">Full Name *</Label>
          <Input
            id="customer-name"
            type="text"
            value={customerName}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="e.g. John Smith"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="customer-email">Email Address *</Label>
          <Input
            id="customer-email"
            type="email"
            value={customerEmail}
            onChange={(e) => onEmailChange(e.target.value)}
            placeholder="e.g. john@example.com"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="customer-phone">Phone Number *</Label>
          <Input
            id="customer-phone"
            type="tel"
            value={customerPhone}
            onChange={(e) => onPhoneChange(e.target.value)}
            placeholder="e.g. +1 (555) 123-4567"
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="contact-method">Preferred Contact Method</Label>
          <Select value={contactMethod} onValueChange={onContactMethodChange}>
            <SelectTrigger id="contact-method">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="email">📧 Email</SelectItem>
              <SelectItem value="phone">📞 Phone Call</SelectItem>
              <SelectItem value="whatsapp">💬 WhatsApp</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="special-requests">Special Requests (Optional)</Label>
          <Textarea
            id="special-requests"
            value={specialRequests}
            onChange={(e) => onSpecialRequestsChange(e.target.value)}
            placeholder="e.g. Dietary restrictions, accessibility needs..."
            rows={3}
          />
        </div>
      </CardContent>
    </Card>
  );
}
